import { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { warn } from '../../services/env';
import { useReactiveVar } from '@apollo/client';
import { CancelIcon, WarningIcon } from './icons';
import { IMessage } from '../../types/common';
import Button from './button';

const Warn = (props: any) => {
    const { style } = props
   
    const message: IMessage = useReactiveVar(warn);

    const [modalOpen, setModalOpen] = useState<boolean>(false)

    useEffect(() => {
        if (message && message.content) {
           toggle()
        }
    }, [message])

    const toggle = () => {
        if (modalOpen) {
            warn({title: '', content: ''})
        } 
        setModalOpen(!modalOpen)
    }

    return <div className='confirm'>
         <Modal role="alertdialog" style={{maxWidth: '600px', ...style}} isOpen={modalOpen} toggle={toggle} backdrop="static">
            {message.title && <ModalHeader toggle={toggle} tag={'h2'} cssModule={{'modal-title': 'w-100 text-center'}}>{message.title}</ModalHeader>}
            <ModalBody className="centered-content">  
                <div dangerouslySetInnerHTML={{ __html: message.content }} />
            </ModalBody>
            <ModalFooter>
                <Button onClick={toggle}><CancelIcon/> Close</Button>
            </ModalFooter>
        </Modal>
    </div>
} 

export default Warn;